import axios from "@/api/axiosInstance";
import { FetchMyTransactionHistoryCsvParams } from "./types";

export const fetchMyTransactionHistoryCsv = async (
  params: FetchMyTransactionHistoryCsvParams = {},
): Promise<Blob> => {
  const response = await axios.get<Blob>(
    "/api/private/my/transaction-history/export",
    { responseType: "blob", params },
  );
  return response.data;
};
